import React from "react";
import { useAppSelector } from "../../../hooks/hooks";
import {
  Container,
  Layout,
  Padding,
  Text,
  CollapsableItemList,
  ContainerLineItem,
  ReportLink,
  Chit,
  // Icon,
  // IconList,
} from "@kidslivesafe/sc-react";

// import ListModal, {
//   ListModalMode,
// } from "../../../components/UIComponents/ListModal/ListModal";

import {
  selectRecentSaleSearchStatus,
  selectPropertyReportRecentSalesData,
  // selectIfReportIsOnList,
  // selectReportLists,
} from "../../../features/reports/reportsSlice";
import {
  generateList,
  fullCapsText,
  formatAddress,
  parseDate,
} from "../../../utils";
import LoadingContainerLineItem from "../../../components/UIComponents/LoadingContainerLineItem/LoadingContainerLineItem";
import {
  PullPropertyReportParams,
  usePropertySearchDispatch,
} from "../../../hooks/propertyReportHook";

// import { recentSalesData } from "../../../features/reports/reportTypes";

import "./NearbySales.css";

const NearbyRecentSales: React.FC<{
  containerId: string;
  printReady?: boolean;
}> = ({ containerId, printReady }) => {
  const recentSaleSearchStatus = useAppSelector(selectRecentSaleSearchStatus);
  const nearbyRecentSales = useAppSelector(selectPropertyReportRecentSalesData);
  const pullPropertyReport = usePropertySearchDispatch();

  const loading = recentSaleSearchStatus === "loading";

  const renderChit = ({ text }: { text: string }) => {
    switch (text) {
      case "Recently Sold":
        return <Chit unresponsive chitText={text} dotColor="grey" />;
      default:
        return null;
    }
  };
  // ------- START-------
  // all used for list function

  // const [mode, setMode] = useState<ListModalMode>("add-report");
  // const [showListModal, setShowListModal] = useState<boolean>(false);
  // const [reportList, setReportList] = useState<recentSalesData | undefined>(
  //   undefined,
  // );
  // const [reportId, setReportId] = useState<number | undefined>(undefined);
  // const [list, setList] = useState<any | undefined>(undefined);

  // // used to know if certain nearby recently sold properties are already in lists display star on list entry
  // const reportLists = useAppSelector(selectReportLists);
  // const listsMap = React.useMemo(() => {
  //   if (!nearbyRecentSales || nearbyRecentSales.length === 0)
  //     return {} as Record<
  //       string,
  //       { foundFlag: boolean; list: any; reportId: number | undefined }
  //     >;

  //   const map: Record<
  //     string,
  //     { foundFlag: boolean; list: any; reportId: number | undefined }
  //   > = {};

  //   for (const item of nearbyRecentSales) {
  //     if (!item.propertyId) continue;
  //     // call the pure helper using the current reportLists
  //     const { foundFlag, list, reportId } = selectIfReportIsOnList(
  //       { reports: { reportLists } } as RootState,
  //       item,
  //     );
  //     map[item.propertyId] = { foundFlag, list, reportId };
  //   }
  //   // reset report being saved to list
  //   setTimeout(() => {
  //     setReportList(undefined);
  //   }, 2000);
  //   return map;
  // }, [nearbyRecentSales, reportLists]);

  // useEffect(() => {
  //   if (reportList && listsMap[reportList?.propertyId].foundFlag) {
  //     setList(listsMap[reportList?.propertyId].list);
  //     setReportId(listsMap[reportList?.propertyId].reportId);
  //     setMode("remove-report");
  //   } else {
  //     setList(undefined);
  //     setReportId(undefined);
  //     setMode("add-report");
  //   }
  // }, [reportList]);

  // const handleFavorite = (property: recentSalesData) => {
  //   setReportList(property);
  //   setShowListModal(true);
  // };
  // ------- End-------

  return (
    <Padding
      left="md"
      right="md"
      breakpointStyles={{
        desktop: {
          space: "none",
        },
      }}
    >
      <Layout type="flex" flexProps={{ direction: "column", gap: "md" }}>
        <Container
          containerTitle={`Nearby Recent Sales ${loading || nearbyRecentSales?.length === 0 ? "" : `(${nearbyRecentSales?.length})`}`}
          containerId={containerId}
          tooltipContent="This section shows up to 20 properties within five miles that are recently sold."
        >
          {loading ? (
            <LoadingContainerLineItem
              lineItemHeader
              lineItemSubHeader
              numberToLoad={5}
            />
          ) : nearbyRecentSales && nearbyRecentSales.length > 0 ? (
            <>
              <CollapsableItemList isOpen={printReady} numberToShow={2}>
                {nearbyRecentSales.map((property, index) => (
                  <div key={property.propertyId}>
                    <Padding top="md" left="md" right="md">
                      <Layout
                        type="flex"
                        flexProps={{
                          direction: "row",
                          alignContent: "space-between",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="nearbyRecentSales__chit-container">
                          {renderChit({
                            text: "Recently Sold",
                          })}
                        </div>
                        {/* <div
                          onClick={e => {
                            e.preventDefault();
                            handleFavorite(property);
                          }}
                          className="nearbyRecentSales__icon-container"
                        >
                          <Icon
                            size={24}
                            name={
                              listsMap[property.propertyId]?.foundFlag
                                ? IconList.IconStar
                                : IconList.IconStarHollow
                            }
                            iconColor="#F2B415"
                          />
                        </div> */}
                      </Layout>
                    </Padding>
                    <ContainerLineItem
                      lineItemHeaderNoWrap
                      lineItemHeader={
                        <ReportLink<PullPropertyReportParams>
                          noWrap
                          text={fullCapsText(
                            formatAddress(property, "with-comma"),
                          )}
                          inputValue={{
                            addressLine1: property.fullStreetAddress,
                            state: property.state,
                            city: property.city,
                            zip: property.zip5,
                            lat: property.latitude,
                            long: property.longitude,
                            propertyId: property.propertyId,
                            nearbySchoolRadius: 5,
                            searchMethod: "LinkClick",
                          }}
                          handleClick={inputValue =>
                            pullPropertyReport(inputValue, "property report")
                          }
                        />
                      }
                      lineItemSubHeader={generateList(
                        [
                          {
                            value: property.lastSoldDate
                              ? parseDate(property.lastSoldDate, "MM/DD/YYYY")
                              : "N/A",
                            label: "Last Sold Date: ",
                          },
                          {
                            value: property.lastSaleAmount
                              ? `$${property.lastSaleAmount.toLocaleString()}`
                              : "N/A",
                            label: "Sale Value: ",
                          },
                        ],
                        " | ",
                      )}
                      lineItemSubHeaderLine2={generateList(
                        [
                          {
                            value: " bds",
                            label: property.bedrooms ? property.bedrooms : null,
                          },
                          {
                            value: " ba",
                            label: property.totalBaths
                              ? property.totalBaths
                              : null,
                          },
                          {
                            value: " sqft",
                            label: property.sumBuildingSqFt
                              ? property.sumBuildingSqFt
                              : null,
                          },
                          {
                            value: " acres",
                            label: property.lotSizeAcres
                              ? property.lotSizeAcres
                              : property.lotSizeAcers //TODO remove when backend is fixed
                                ? property.lotSizeAcers
                                : null,
                          },
                        ],
                        " | ",
                      )}
                      subContent={
                        <Text size="xs">
                          {property.landUseDescription?.toUpperCase() || "N/A"}
                        </Text>
                      }
                      isOpen={printReady ? true : false}
                      key={index}
                    />
                  </div>
                ))}
              </CollapsableItemList>
            </>
          ) : (
            <Text>There are no recent sales near this property</Text>
          )}
        </Container>
      </Layout>
      {/* <ListModal
        modalMode={mode}
        setModalMode={setMode}
        displayModal={showListModal}
        setDisplayModal={setShowListModal}
        report={reportList}
        reportId={reportId ? reportId : undefined}
        list={list ? list : undefined}
      /> */}
    </Padding>
  );
};

export default NearbyRecentSales;
